module.exports = __webpack_public_path__ + "static/media/fitbit-logo-text.a9db3f0d.svg";